import $ from 'jquery';

const eventHandlers = [];
let previousBreakpoint = null;

$(window).on('resize', (event) => {
  const currentBreakpoint = getBreakpoint();

  if (previousBreakpoint !== currentBreakpoint) {
    for (let eventHandler of eventHandlers) {
      eventHandler(event, {
        previous: previousBreakpoint,
        current: currentBreakpoint,
      });
    }
  }

  previousBreakpoint = currentBreakpoint;
});

function getBreakpoint() {
  return window
    .getComputedStyle(document.documentElement, ':after')
    .getPropertyValue('content')
    .replace(/"/g, '');
}

function isBreakpoint(breakpoint) {
  return getBreakpoint() === breakpoint;
}

function onBreakpointChange(eventHandler) {
  if (eventHandlers.indexOf(eventHandler) === -1) {
    eventHandlers.push(eventHandler);
  }
}

function offBreakpointChange(eventHandler) {
  const index = eventHandlers.indexOf(eventHandler);

  if (index !== -1) {
    eventHandlers.splice(index, 1);
  }
}

export default {
  isBreakpoint,
  onBreakpointChange,
  offBreakpointChange,
};
